// Use the POS device's local day; never roll the choices into tomorrow.
export const getExpectedStartTimeOptions = (now = new Date()) => {
    const options = [];
    for (let hour = now.getHours(); hour < 24; hour += 1) {
        for (const minute of [0, 15, 20, 30, 45]) {
            const candidate = new Date(now);
            candidate.setHours(hour, minute, 0, 0);
            if (candidate >= now) {
                options.push(`${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`);
            }
        }
    }
    return options;
};

export const normalizeExpectedStartTime = (value) => {
    if (!value) return "";
    const [hour, minute] = String(value).split(":");
    return `${hour.padStart(2, "0")}:${minute}`;
};
